<div class="crm-header">
  <header data-aos="zoom-in">
    <div class="container">
      <div class="row-custom">
        <div class="col-sm-12-custom">
          <div class="inner-header">
            <div class="menus">
              <nav class="animenu" [class.animenu--open]="menuOpen">
                <button class="animenu__btn" type="button" (click)="menuOpen = !menuOpen">
                  <span class="animenu__btn__bar"></span>
                  <span class="animenu__btn__bar"></span>
                  <span class="animenu__btn__bar"></span>
                </button>
                <ul class="animenu__nav">
                  <li><a (click)="changeTab('home'); menuOpen=false">Home</a></li>
                  <li><a (click)="changeTab('price'); menuOpen=false">Pricing</a></li>
                  <li><a (click)="changeTab('login'); menuOpen=false" *ngIf="currentTab !== 'login'">Login</a></li>
                  <li><a [routerLink]="'/business-register'" (click)="menuOpen=false">SignUp</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>

<div *ngIf="currentTab == 'home'">
  <app-crm-home></app-crm-home>
</div>

<div *ngIf="currentTab == 'price'">
  <app-crm-price [currency]="currency"></app-crm-price>
</div>

<div class="inner-page-bg-right" *ngIf="currentTab == 'login'">
  <header>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="inner-header">
            <div class="logo">
              <a href="javascript:void();" [routerLink]="'/login'"> <img src="assets/crm_images/logo-inner.png"
                  alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="banner-inner-pages">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-7 col-lg-5">
          <div class="banner-left-text mt-5">
            <h3>Let’s Get</h3>
            <h1>You Started!</h1>
          </div>
          <h2 class="mt-5">Registered User Login</h2>
          <form [formGroup]="loginForm" class="form-container" (ngSubmit)="login()" autocomplete="off">
            <div class="row">
              <div class="col-sm-12">
                <mat-form-field appearance="outline">
                  <mat-label>Email/Username</mat-label>
                  <input matInput formControlName="email" oninput="this.value = this.value.toLowerCase()"
                    placeholder="Email/Username" type="text">
                  <mat-error *ngIf="submitted && f.email.errors?.required" class="invalid-feedback">
                    Email/Username is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">

                <mat-form-field appearance="outline">
                  <mat-label>Password</mat-label>
                  <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                    placeholder="Password" maxlength="10" />
                  <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()">
                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="submitted && f.password.errors?.required" class="invalid-feedback">
                    Password is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row delegateAccess">
              <div class="col-sm-12">
                <mat-checkbox formControlName="delegateAccess">
                  Delegate Access
                </mat-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <button type="submit" mat-raised-button color="primary">Login</button>
              </div>
              <div class="col-8 text-right">
                <a style="text-decoration: none;" href="#/forget-password">Forgot Password?</a>
              </div>
            </div>
          </form>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-7 signup-img"> <img src="assets/crm_images/signup-1.png" alt="">
        </div>
      </div>
    </div>
  </section>
  <div class="button-container">
    <div id="popup" class="popup" [class.show]="isPopupVisible">
      <img [src]="angularProjectURL" alt="Scan QR" />
    </div>
    <div class="icons">
    </div>
  </div>
</div>
<app-admin-footer></app-admin-footer>
